import type { ViewConfigKpiWithMetric } from '@salescore/core'
import { useRecoilState } from 'recoil'

import { configAtom } from '../../viewConfig'

export const useViewConfigKpi = (): [ViewConfigKpiWithMetric, (kpiConfig: ViewConfigKpiWithMetric) => void] => {
  const [config, setConfig] = useRecoilState(configAtom)
  if (config.type !== 'kpi') {
    // このエラーが発生するならKPI以外のビューでこのhookを使っているため、使うべきhookを間違っているはず
    throw new Error(`oldConfigがundefinedです`)
  }

  return [config, setConfig]
}
